import projects from '../../data/projectsData'; // or the correct path
import ProjectCard from './ProjectCard';

export default function Projects() {
  return (
    <section id="projects">
      <h2>Projects</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {projects.map(project => (
          <ProjectCard key={project.id} {...project} />
        ))}
      </div>
    </section>
  );
}
